// extracted by mini-css-extract-plugin
module.exports = {"author-label":"_9e1425b4d3--author-label--u2SQA"};